import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackButton({ to, label = "Back", className = "", testid = "back-btn", onClick }) {
  const navigate = useNavigate();
  const loc = useLocation();
  const go = () => {
    if (onClick) return onClick();
    if (to) return navigate(to);
    if (loc.key !== "default" && window.history.length > 1) navigate(-1);
    else navigate("/");
  };
  return (
    <button type="button" onClick={go} className={`inline-flex items-center gap-1.5 text-xs font-semibold text-gray-300 hover:text-[#E5C158] border border-white/10 hover:border-[#D4AF37]/60 rounded-full px-3 py-1.5 transition-colors ${className}`} data-testid={testid}>
      <ArrowLeft className="w-3.5 h-3.5" />{label}
    </button>
  );
}
